var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 20,
    viewBox: "0 0 142 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "v57w737iaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024 0v768H0V0h1024z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4rct6ghcob"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.42 18.586V20L120.433 20l1.04-1.414h19.947zM38.86 7.668c1.246 0 1.23.472.62 1.297-.617.837-1.668 2.276-2.298 3.125-.319.433-.897 1.219 1.017 1.219h15.087c-1.254 1.719-5.324 6.69-12.632 6.69h-22.13l9.075-12.331h11.262zm31.638 5.64-4.921 6.69H52.595s4.918-6.69 4.923-6.69h12.98zm-53.315 5.278L16.143 20H0v-1.413h17.183zm72.089-5.277-4.924 6.689H71.37s4.919-6.69 4.924-6.69h12.978zm33.708 0-4.923 6.689H97.214c-5.32 0-6.76-2.566-5.13-4.77l.439-.595.197-.269.773-1.055h29.487zm18.44 2.638v1.421h-19.05l1.044-1.42h18.007zm-122.295 0-1.045 1.42H0v-1.42h19.125zm122.296-2.638v1.42l-17.109.001 1.044-1.421h16.065zm-120.353 0-1.047 1.42H0v-1.42h21.068zM50.929 0c6.618 0 8.308 5.227 6.457 7.74-1.36 1.846-2.983 4.055-2.983 4.055h-10.07c-1.659 0-1.446-.591-1.152-1.03l.069-.097c.022-.032.045-.062.066-.09.63-.85 1.663-2.306 2.281-3.142.608-.824.625-1.297-.62-1.297H20.352L24.87 0h26.06zm66.11 0-8.681 11.795H94.607s1.7-2.311 3.598-4.887l.424-.576.213-.29.427-.58C101.329 2.667 103.292 0 103.294 0h13.745zM80.294 0l-4.976 6.763h5.792L86.09 0h12.976l-8.68 11.794H58.633L67.316 0h12.978z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v57w737iaa)",
    transform: "translate(-312 -391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4rct6ghcob)",
    transform: "translate(312 391)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E30017",
    d: "M0 0h141.42v20H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogo);
export default __webpack_public_path__ + "static/media/dhl_logo.3aa28aa05eb1fd755be4f0cd0f8dbdbc.svg";
export { ForwardRef as ReactComponent };